import React from "react";
import { projects } from "../data/projects";
import '../css/global.css';
import '../css/Projects.css';

const Projects: React.FC = () => {
    return(
        <section className="projects" id="myWork">
            <div className="container">
            <div className="header-content">
                <span className="sub-heading">Featured Projects</span>
                <h3>Things I'm Building</h3>
                <div className="section-divider">
                    <svg
                        width="80"
                        height="16"
                        viewBox="0 0 80 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M2 8 C8 2, 14 2, 20 8
                            S32 14, 38 8
                            S50 2, 56 8
                            S68 14, 78 8"
                            stroke="#B8E986"
                            strokeWidth="4"
                            strokeLinecap="round"
                            fill="none"
                        />
                    </svg>
                </div>
            </div>
            <div className="row justify-content-center">
            {projects.map((project) => (
            <div className="project-col col-sm-3 d-flex" key={project.id}>
               <div className="projects__card">
                    <span><i className={`${project.icon} ${project.iconColor}`}></i></span>
                    <img src={project.image}
                        className="img-fluid"
                        alt={project.title} 
                    />
                    <div className="card-info">
                        <div className="project-header-info">
                            <h3 className="project-title">{project.title}</h3>
                            {project.status && (
                            <span className={`project-status ${project.color}`}>
                            {project.status}
                            </span>
                        )}
                        {project.status !== "In Progress" && (
                        <div className="card-buttons">
                           <a href={project.demo} className="btn btn-primary btn-demo" target="_blank" rel="noreferrer">
                                Live Demo{" "}
                                <i className="fa-solid fa-arrow-up-right-from-square"></i>
                            </a>
                            
                         </div>
                         )}
                        </div>
                        <p>{project.description}</p>
                        <ul className={`project__code-list ${project.color}`}>
                            {project.technologies.map((tech) => (
                                <li key={tech}>{tech}</li>
                            ))}
                        </ul>

                    </div>
                </div>
            </div>
           ))}
           </div>
         </div>
      </section>
    );
}

export default Projects;